import { render, staticRenderFns } from "./PlusIndicator.vue?vue&type=template&id=2b4378d1&scoped=true"
import script from "./PlusIndicator.vue?vue&type=script&lang=js"
export * from "./PlusIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4378d1",
  null
  
)

export default component.exports